import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IIncelemeBirimiForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IIncelemeBirimiForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: string;
  GoBack_dummy: string;
  A_IncelemeBirimiById: any[];
  A_IncelemeBirimiById_dummy: any[];
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  wfScreenName: string;
}

export class IncelemeBirimiForm_ScreenBase extends React.PureComponent<IIncelemeBirimiForm_ScreenProps, any> {
  ml = [
    {
      Id: "4f05fda5-b043-9e86-8437-71ea4357a314",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: []
    },
    { Id: "7a8fc238-9831-4128-a954-0cdac59f257a", Name: "en_US", ShortName: "English", LanguagePhrases: [] },
    {
      Id: "d076022e-9d3d-4f71-a9ab-fbbba0fbd673",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "İnceleme Birimi Formu" },
        { Id: 9101393, PropertyName: "value", Value: "Kod" },
        { Id: 8931056, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 1901198, PropertyName: "value", Value: "Tanım" },
        { Id: 2580944, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 667200, PropertyName: "value", Value: "Ürün Grubu" },
        { Id: 908915, PropertyName: "value", Value: "Ayakkabı" },
        { Id: 273822, PropertyName: "value", Value: "Çanta" },
        { Id: 406491, PropertyName: "value", Value: "Giysi" },
        { Id: 501341, PropertyName: "value", Value: "Talep Türü" },
        { Id: 431819, PropertyName: "value", Value: "Değişim" },
        { Id: 831463, PropertyName: "value", Value: "İade" },
        { Id: 471310, PropertyName: "value", Value: "Tadilat" },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" }
      ]
    }
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.incelemebirimiform_8931056_value_kuikaTextInputRef = React.createRef();
    this.incelemebirimiform_2580944_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      A_IncelemeBirimiById: [],
      SaveRecord_1: false,
      wfScreenName: ""
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("incelemebirimiform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.IncelemeBirimiFormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("incelemebirimiform", "");
  }

  componentWillUnmount() {}

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["SSHAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (!permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText = "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText = "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText = "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText = "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("incelemebirimiform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.IncelemeBirimiFormPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      incelemebirimiform_8931056_value: this.state.A_IncelemeBirimiById?.at?.(0)?.code ?? undefined,
      incelemebirimiform_2580944_value: this.state.A_IncelemeBirimiById?.at?.(0)?.name ?? undefined,
      incelemebirimiform_862177_value: this.state.A_IncelemeBirimiById?.at?.(0)?.isAyakkabi ?? undefined,
      incelemebirimiform_130322_value: this.state.A_IncelemeBirimiById?.at?.(0)?.isCanta ?? undefined,
      incelemebirimiform_132837_value: this.state.A_IncelemeBirimiById?.at?.(0)?.isGiysi ?? undefined,
      incelemebirimiform_997569_value: this.state.A_IncelemeBirimiById?.at?.(0)?.isDegisim ?? undefined,
      incelemebirimiform_947937_value: this.state.A_IncelemeBirimiById?.at?.(0)?.isIade ?? undefined,
      incelemebirimiform_189458_value: this.state.A_IncelemeBirimiById?.at?.(0)?.isTadilat ?? undefined
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  IncelemeBirimiFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(this.props.screenInputs.Id ?? this.props.screenInputs.id, "Guid")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "IncelemeBirimiForm/IncelemeBirimiFormPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.A_IncelemeBirimiById = result?.data.a_IncelemeBirimiById;
    formVars.incelemebirimiform_8931056_value = ReactSystemFunctions.toString(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].code
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].code
        : null
    );
    formVars.incelemebirimiform_2580944_value = ReactSystemFunctions.toString(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].name
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].name
        : null
    );
    formVars.incelemebirimiform_862177_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isAyakkabi
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isAyakkabi
        : null
    );
    formVars.incelemebirimiform_130322_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isCanta
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isCanta
        : null
    );
    formVars.incelemebirimiform_132837_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isGiysi
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isGiysi
        : null
    );
    formVars.incelemebirimiform_997569_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isDegisim
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isDegisim
        : null
    );
    formVars.incelemebirimiform_947937_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isIade
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isIade
        : null
    );
    formVars.incelemebirimiform_189458_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isTadilat
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isTadilat
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.IncelemeBirimiFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  IncelemeBirimiFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.incelemebirimiform_8931056_value = ReactSystemFunctions.toString(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].code
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].code
        : null
    );

    formVars.incelemebirimiform_2580944_value = ReactSystemFunctions.toString(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].name
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].name
        : null
    );

    formVars.incelemebirimiform_862177_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isAyakkabi
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isAyakkabi
        : null
    );

    formVars.incelemebirimiform_130322_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isCanta
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isCanta
        : null
    );

    formVars.incelemebirimiform_132837_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isGiysi
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isGiysi
        : null
    );

    formVars.incelemebirimiform_997569_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isDegisim
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isDegisim
        : null
    );

    formVars.incelemebirimiform_947937_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isIade
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isIade
        : null
    );

    formVars.incelemebirimiform_189458_value = ReactSystemFunctions.value(
      this,
      stateVars.A_IncelemeBirimiById !== undefined
        ? stateVars.A_IncelemeBirimiById?.length > 0
          ? stateVars.A_IncelemeBirimiById[0].isTadilat
          : null
        : this.state.A_IncelemeBirimiById?.length > 0
        ? this.state.A_IncelemeBirimiById[0].isTadilat
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  IncelemeBirimiFormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  IncelemeBirimiFormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(this.props.screenInputs.Id ?? this.props.screenInputs.id, "Guid"),
      IsAyakkabi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_862177_value", "value", "", "", "")
        ),
        "boolean"
      ),
      IsCanta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_130322_value", "value", "", "", "")
        ),
        "boolean"
      ),
      IsDegisim_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_997569_value", "value", "", "", "")
        ),
        "boolean"
      ),
      IsGiysi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_132837_value", "value", "", "", "")
        ),
        "boolean"
      ),
      IsIade_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_947937_value", "value", "", "", "")
        ),
        "boolean"
      ),
      IsTadilat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_189458_value", "value", "", "", "")
        ),
        "boolean"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_2580944_value", "value", "", "", "")
        ),
        "string"
      ),
      Code_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "incelemebirimiform_8931056_value", "value", "", "", "")
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "IncelemeBirimiForm/IncelemeBirimiFormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.IncelemeBirimiFormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  IncelemeBirimiFormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }

  getWfPageComponent = () => {
    return ReactSystemFunctions.getWfPageComponent(this, this.state.wfScreenName);
  };
}
